import { computed } from 'mobx';

export default class LocationModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = +item.id;
    this.name = item.name;
    this.description = item.description;
    this.parent_id = item.parent_id
    this.type_id = item.type_id;
    this.seq = item.seq;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      parent_id: this.parent_id,
      type_id: this.type_id,
      seq: this.seq
    };
  }

  updateFromJson(item) {
    this.id = +item.id;
    this.name = item.name;
    this.description = item.description;
    this.parent_id = item.parent_id
    this.type_id = item.type_id;
    this.seq = item.seq;
  }
}



// WEBPACK FOOTER //
// ./src/models/Location/LocationModel.js